import type { AppRole } from '../../services/auth/roleService'
import type { AuthContextValue } from './context'

export type AuthorizationDecision = 'loading' | 'signed_out' | 'error' | 'pending' | 'allowed' | 'denied'

export function authIsResolving(loading: boolean, phase: AuthContextValue['phase']): boolean {
  return loading || phase === 'authenticating' || phase === 'firebase_resolved' || phase === 'membership_resolving'
}

export function getAuthorizationDecision(auth: Pick<AuthContextValue, 'user' | 'role' | 'schoolId' | 'loading' | 'phase' | 'error'>, requiredRole?: AppRole): AuthorizationDecision {
  if (auth.phase === 'signed_out' && !auth.user) return 'signed_out'
  if (authIsResolving(auth.loading, auth.phase) || auth.phase !== 'resolved') return 'loading'
  if (!auth.user) return 'signed_out'
  if (auth.error) return 'error'
  if (!auth.role || !auth.schoolId) return 'pending'
  if (requiredRole && auth.role !== requiredRole) return 'denied'
  return 'allowed'
}

export function defaultPathForRole(role: AppRole): string {
  return `/${role}`
}

export function pathIsAllowedForRole(pathname: string | undefined, role: AppRole): boolean {
  if (!pathname) return false
  const pathOnly = pathname.split(/[?#]/, 1)[0]
  if (role === 'admin') return pathOnly === '/admin' || pathOnly.startsWith('/admin/')
  if (role === 'employee') return pathOnly === '/employee' || pathOnly.startsWith('/employee/')
  return pathOnly === '/parent' || pathOnly.startsWith('/parent/')
}

export function safePostLoginPath(pathname: string | undefined, role: AppRole): string {
  return pathIsAllowedForRole(pathname, role) ? pathname! : defaultPathForRole(role)
}
